import * as Yup from "yup";
const VALIDATE_MESSAGE = {
  required: "Thông tin bắt buộc"
};

export const ValidateSchema = Yup.object().shape({
  name: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  maChucNang: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  app: Yup.object()
    .shape({
      id: Yup.number()
    })
    .nullable(VALIDATE_MESSAGE.required)
    .required(VALIDATE_MESSAGE.required),
  linhVuc: Yup.object()
    .shape({
      id: Yup.number()
    })
    .nullable(VALIDATE_MESSAGE.required)
    .required(VALIDATE_MESSAGE.required),
  module: Yup.object()
    .shape({
      id: Yup.number()
    })
    .nullable(VALIDATE_MESSAGE.required)
    .required(VALIDATE_MESSAGE.required)
});

export const ValidateSchemaUpdate = Yup.object().shape({
  name: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  maChucNang: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  module: Yup.object()
    .shape({
      id: Yup.number()
    })
    .nullable(VALIDATE_MESSAGE.required)
    .required(VALIDATE_MESSAGE.required)
});
